import { CircularProgress } from "@mui/material";
import React, { useState } from "react";
import NewAxiosInstance from "../../api/api";
import toast from "react-hot-toast";

export default function BulkCallTab() {
  const [loading, setLoading] = useState(false);
  const [file, setFile] = useState<any>();
  const callFunction = () => {
    if (loading) return;
    setLoading(true);
    const formData = new FormData();
    formData.append("file", file);
    const config = {
      headers: {
        "content-type": "multipart/form-data",
      },
    };
    NewAxiosInstance()
      .post("/crm/marketing/make/bulk/call", formData, config)
      .then((data) => {
        toast.success("Success", {
          duration: 3000,
        });
        // setLogPhoneNumber(values.phoneNumber);
      })
      .catch((error) => {
        toast.error(error?.response?.data?.message, {
          duration: 3000,
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };
  return (
    <div>
      <div className="flex gap-8   items-center  w-[100%]  flex-wrap justify-center">
        <input
          type="file"
          accept=".csv"
          onChange={(event: any) => {
            if (event.target.files && event.target.files[0].size > 20971520) {
              alert("File is too big! Maximum file size is 20 MB");
              event.target.value = null;
              console.log(event.target);
              return;
            }
            setFile(event.target.files[0]);
          }}
        ></input>
        <button
          onClick={() => {
            if (!file) {
              alert("Please select a file");
            } else {
              callFunction();
            }
          }}
          className={`bg-primary-dark px-4 py-2 rounded-md text-white text-[1.1rem] font-[500] ml-5 w-[150px] ${
            loading && "bg-slate-50 "
          }`}
          // type="submit"
        >
          {loading ? (
            <>
              <CircularProgress color="secondary" size={20} />{" "}
              <span className="text-black">Loading</span>
            </>
          ) : (
            "Submit"
          )}
        </button>
      </div>
    </div>
  );
}
